/* Croatian Jewellery — Our Story: slow scroll reveals.
   Lightweight, no dependencies, respects prefers-reduced-motion.
   Each story section references this file, so it guards against running twice. */
(function () {
  if (window.__cjStoryLoaded) return;
  window.__cjStoryLoaded = true;

  function revealAll(els) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('cj-in');
  }

  function init() {
    var els = document.querySelectorAll('[data-cj-reveal]:not(.cj-in)');
    if (!els.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    if (reduce || designMode || !('IntersectionObserver' in window)) {
      revealAll(els);
      return;
    }

    if (!window.__cjStoryObserver) {
      window.__cjStoryObserver = new IntersectionObserver(function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.classList.add('cj-in');
            obs.unobserve(entries[i].target);
          }
        }
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    }

    for (var j = 0; j < els.length; j++) window.__cjStoryObserver.observe(els[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
